import { useState } from "react";

export type PitchView = "pitch" | "list";

export const usePitchView = () => {
  const [activeView, setActiveView] = useState<PitchView>("pitch");

  const handleViewChange = (keys: Set<PitchView>) => {
    setActiveView(Array.from(keys)[0]);
  };

  return { activeView, handleViewChange };
};
